module.exports = __webpack_public_path__ + "static/img/012.d8acfd73.jpg";